module.exports = __webpack_public_path__ + "static/media/add_business_black.71ff42e2.svg";